import React from 'react';

interface SubmitErrorBannerProps {
  message: string | null;
}

export default function SubmitErrorBanner({ message }: SubmitErrorBannerProps) {
  if (!message) return null;
  return (
    <div className="mb-4 p-3 rounded-xl bg-red-50 border border-red-200 text-sm text-red-700 text-center">
      {message}
    </div>
  );
}
